import React from 'react';
import RequestOrganiserForm from '../components/RequestOrganiserForm';
import ApproveOrganiserList from '../components/ApproveOrganiserList';
import GroupInviteList from '../components/GroupInviteList';
import PendingGroupMembers from '../components/PendingGroupMembers';

export default function OrganiserTools() {
  const mockUser = {
    invitations: [
      { groupId: 3, groupName: "Group C" },
      { groupId: 4, groupName: "Group D" }
    ],
    organisedGroups: [
      { id: 1, name: "Group A" },
      { id: 2, name: "Group B" }
    ]
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Organiser Tools - Test Page</h2>
      
      <RequestOrganiserForm />
      <hr />
      
      <ApproveOrganiserList />
      <hr />
      
      <GroupInviteList invitations={mockUser.invitations} />
      <hr />
      
      {mockUser.organisedGroups.map(group => (
        <div key={group.id}>
          <h3>Pending Members in {group.name}</h3>
          <PendingGroupMembers groupId={group.id} />
          <hr />
        </div>
      ))}
    </div>
  );
}
